<template>
    <div class="versions">
        <div class="card table-card mb-3">
            <div class="card-body p-0">
                <table class="table table-without-pagination">
                    <thead>
                        <tr>
                            <th class='ps-3 align-middle pt-2'>Version Name</th>
                            <th class="align-middle pt-2">Status</th>
                            <th class="align-middle pt-2 d-none d-md-table-cell">Created On</th>
                            <th class="align-middle pt-2 d-none d-md-table-cell">Created By</th>
                            <th class="align-middle pt-2 d-none d-md-table-cell">Updated On</th>
                            <th class="align-middle pt-2 d-none d-md-table-cell">Updated By</th>
                            <th class="align-middle pt-2">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="table-border-bottom-0">
                        <tr v-for="(plan, index) in plans" :key="plan.id" :id="'row' + plan.id">
                            <td class='ps-3 align-middle' v-if="plan.client_id !== null">
                                <a :href="'/planning/' + plan.url + '/annual'">{{ plan.name }}</a>
                            </td>
                            <td class='ps-3 m align-middle' colspan="2" v-else>
                                <div class="spinner-border spinner-border-sm text-warning float-left" role="status">
                                    <span class="visually-hidden">Copying...</span>
                                </div> 
                                <span class="ms-2">Copying...</span>
                            </td>
                            <td class="align-middle">
                                <span class="badge rounded-pill badge-primary" v-if="plan.is_published_plan === 1">Published</span>
                                <span class="badge rounded-pill badge-secondary" v-else-if="plan.is_active_plan === 1">Draft</span>
                            </td>
                            <td class="align-middle d-none d-md-table-cell" v-if="plan.client_id !== null">
                                {{ date(plan.created_at) }}
                            </td>
                            <td class="align-middle d-none d-md-table-cell">
                                <img v-if="plan.client_id !== null"
                                    class="avatar rounded-circle me-3" 
                                    data-bs-toggle="tooltip"
                                    data-popup="tooltip-custom" 
                                    data-bs-placement="top"
                                    :data-bs-original-title="plan.creator.name"
                                    :src="plan.creator.image" />
                            </td>
                            <td class="align-middle d-none d-md-table-cell">
                                {{ date(checkDuplicate(plan.created_at, plan.updated_at, plan.updated_at)) }}
                            </td>
                            <td class="align-middle d-none d-md-table-cell">
                                <img v-if="plan.client_id !== null"
                                    class="avatar rounded-circle me-3"
                                    data-bs-toggle="tooltip"
                                    data-popup="tooltip-custom" 
                                    data-bs-placement="top"
                                    :data-bs-original-title="plan.updater.name"
                                    :src="plan.updater.image" />
                            </td>
                            <td class="align-middle">
                                <div class="dropdown">
                                    <button class="btn btn-secondary" 
                                        type="button"
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false">
                                        <i class="fas fa-caret-down me-0"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-primary">
                                        <li>
                                            <a class="dropdown-item" :href="'/planning/' + plan.url + '/annual'">View Plan</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" :href="'/planning/' + plan.url + '/assumptions'">View Assumptions</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="editPlan(plan.id)">Edit Title</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" 
                                                href="#" 
                                                v-if="plan.is_published_plan === 0"
                                                @click.prevent="setAsPublished(plan)">Publish Plan</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" 
                                                href="#" 
                                                v-if="plan.is_active_plan === 0"
                                                @click.prevent="setAsActive(plan)" 
                                                title="Edit">Set as Primary Draft</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="copyPlan(plan.id)">Clone Plan</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="transferPlan(plan)">Transfer Plan</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" 
                                                href="#" 
                                                @click.prevent="deletePlan(plan)"
                                                v-if="!(plan.is_active_plan === 1 || plan.is_published_plan === 1)">Delete Plan</a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h3 v-if="plan.id === null">Create a Blank Plan</h3>
                <h3 v-else>Edit This Plan Name</h3>
                <!-- Name -->
                <div class="pb-3" id="form_start">
                    <label class="form-label">Name</label>
                    <input type="text" 
                        class="form-control" 
                        name="name" 
                        v-model="plan.name"
                        :class="errors.name !== '' ? 'is-invalid' : ''" aria-label="Name">
                    <div class="text-danger invalid-feedback" v-if="errors.name !== ''">
                        {{ errors.name }}
                    </div>
                </div>
                <!-- Success Message -->
                <div class="alert alert-success pb-3" v-if="form.successful">
                    Your information has been updated!
                </div>
                <div class="alert alert-danger pb-3" v-if="form.error">
                    There was an error saving your information. Please tell Kevin.
                </div>
                <div class="pb-3">
                    <button type="submit" class="btn btn-primary" @click.prevent="update" :disabled="form.busy || hasError()">
                        <img class="icon" src="/img/icons/avid-icons/save.svg" alt=""> {{ plan.id === null ? "Save" : "Update" }}
                    </button>
                    <button type="button" class="btn btn-secondary ms-2" @click="resetPlan()" v-if="plan.id !== null">
                        <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import Swal from 'sweetalert2';

export default defineComponent({
    name: 'Versions',
    components: {
        Swal
    },
    props: {
        plans: {
            type: Array,
            required: true
        },
        client: {
            type: Object,
            required: true
        },
        client_list: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            pos: -1,
            plan: {
                id: null,
                name: "",
                is_active_plan: false,
                is_published_plan: false,
                client_id: null
            },
            form: {
                successful: false,
                busy: false,
                error: false
            },
            errors: {
                name: ""
            }
        };
    },
    filters: {
        date(value) {
            if(value === null) return "";
            return moment.utc(value).local().format('M/DD/YYYY h:mm a');
        }
    },
    mounted() {
        this.plan.client_id = this.client.id;
    },
    methods: {
        editPlan(id) {
            for(let i = 0; i < this.plans.length; i++) {
                if(this.plans[i].id === id) {
                    this.pos = i;
                    this.plan = JSON.parse(JSON.stringify(this.plans[i]));
                    break;
                }
            }

            $('html,body').animate({ scrollTop: $("#form_start").offset().top}, 400);
        },
        copyPlan(id) {
            this.form.busy = true;

            //Insert a blank placehold to show that it is loading
            this.plans.push({
                id: null,
                name: "",
                is_active_plan: false,
                is_published_plan: false,
                client_id: null
            });

            window.axios.get('/api/annual_plan/clone/' + id)
                .then(response => {
                    this.form.busy = false;
                    this.plans.pop();
                    if(response.status === 200) {
                        //Add the new plan to the list
                        this.plans.push(response.data.data);
                        this.form.successful = true;
                    } else {
                        this.form.error = true;
                        setTimeout(() => { this.form.error = false; }, 10000);
                    }
                });
        },
        resetPlan() {
            //Reset the "active" plan
            this.plan.id = null;
            this.plan.name = "";
            this.plan.is_active_plan = false;
            this.plan.is_published_plan = false;

            this.pos = -1;
        },
        setAsActive(plan) {
            this.plan = plan;
            this.plan.is_active_plan = true;
            this.update();
        },
        setAsPublished(plan) {
            this.plan = plan;
            this.plan.is_published_plan = true;
            this.update();
        },
        update() {
            if(this.plan.name === "") {
                this.errors.name = 'Please enter a name for this plan.';
                return;
            }

            this.form.busy = true;

            //Make a new plan
            if(this.plan.id === null) {
                window.axios.post('/api/client/' + this.client.id + '/annual_plan', this.plan)
                    .then(response => {
                        this.form.busy = false;
                        if(response.status === 200) {
                            //Reset the active plans if the new one is set to active
                            if(response.data.data.is_active_plan === 1)
                                for(let i = 0; i < this.plans.length; i++)
                                    this.plans[i].is_active_plan = 0;

                            //Reset the active plans if the new one is set to published
                            if(response.data.data.is_published_plan === 1)
                                for(let i = 0; i < this.plans.length; i++)
                                    this.plans[i].is_published_plan = 0;

                            //Add the new plan to the list
                            this.plans.push(response.data.data);
                            this.form.successful = true;

                            this.resetPlan();

                            setTimeout(() => { this.form.successful = false; }, 5000);
                        } else {
                            this.form.error = true;
                            setTimeout(() => { this.form.error = false; }, 10000);
                        }
                    });
            } else {
                window.axios.put('/api/annual_plan/' + this.plan.id, this.plan)
                    .then(response => {
                        this.form.busy = false;
                        if(response.status === 200) {
                            this.form.successful = true;

                            //Reset the active plans if the new one is set to active
                            if(response.data.data.is_active_plan === 1)
                                for(let i = 0; i < this.plans.length; i++)
                                    if(response.data.data.id !== this.plans[i].id)
                                        this.plans[i].is_active_plan = 0;

                            //Reset the active plans if the new one is set to published
                            if(response.data.data.is_published_plan === 1)
                                for(let i = 0; i < this.plans.length; i++)
                                    this.plans[i].is_published_plan = 0;

                            for(let i = 0; i < this.plans.length; i++)
                                if(this.plans[i].id === this.plan.id)
                                    this.plans[i] = response.data.data;

                            this.resetPlan();

                            setTimeout(() => { this.form.successful = false; }, 5000);
                        } else {
                            this.form.error = true;
                            setTimeout(() => { this.form.error = false; }, 10000);
                        }
                    });
            }
        },
        checkDuplicate(created, updated, value) {
            if(created === updated)
                return null;
            return value;
        },
        hasError() {
            return this.errors.name !== "";
        },
        deletePlan(p) {
            Swal.fire({
                title: "Are you sure you want to delete " + p.name + "?",
                text: "This will remove the plan and any associated initiatives from Avid.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete",
                customClass: {
                    popup: 'swal-warning'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/annual_plan/' + p.id)
                        .then(response => {
                            if (response.status === 200) {
                                Swal.fire({
                                    title: "Deleted!",
                                    text: p.name + " has been deleted.",
                                    icon: "success",
                                    customClass: {
                                        popup: 'swal-success'
                                    }
                                }).then(() => {
                                    //Remove it from the array
                                    for(let i = 0; i < this.plans.length; i++)
                                        if(this.plans[i].id === p.id) {
                                            this.plans.splice(i, 1);
                                            this.$forceUpdate();
                                            break;
                                        }
                                });
                            }
                        });
                }
            });
        },
        transferPlan(plan) {
            const options = {};
            for(let i = 0; i < this.client_list.length; i++)
                options[this.client_list[i].id] = this.client_list[i].name;

            Swal.fire({
                title: "Select the client to receive the plan",
                text: "This will duplicate \"" + plan.name + "\" to the selected client. Once duplicated, you'll need to edit the assumptions and inputs for each initative.",
                showCancelButton: true,
                confirmButtonText: "Copy Plan",
                input: 'select',
                inputOptions: options,
                customClass: {
                    popup: 'swal-warning'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const vars = {
                        source_plan_id: plan.id,
                        destination_client_id: result.value
                    };
                    window.axios.post('/api/annual_plan/transfer', vars)
                        .then(response => {
                            if (response.status === 200) {
                                window.location = "/planning/" + response.data.plan.url + "/assumptions";
                            }
                        });
                }
            });
        }
    }
});
</script>
